import { render, staticRenderFns } from "./CancellationRequests.vue?vue&type=template&id=f11bbf14&"
import script from "./CancellationRequests.vue?vue&type=script&lang=js&"
export * from "./CancellationRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports